import { type Property } from '$lib/satellite.types';

export const isActirise = (property: Property): boolean => {
	return !property.adsenseId;
};
